import { apiProxy } from '@/libs/api/apiProxy'
import { PostFavoriteResponse } from '@/types/favorite'

export const PostFavorite = (
  summaryId: number,
  isFavorite: boolean
): Promise<PostFavoriteResponse> => {
  return apiProxy.post<PostFavoriteResponse>(`/api/favorite/${summaryId}`, {
    favorite: isFavorite,
  })
}
